import {
  rerunOn28vy04vs1j44i as rerunOn,
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../components/nav/crowpay.mjs';
import { CollectFundsThroughDirectDepositDialog3q4mipmgpm4q8 as CollectFundsThroughDirectDepositDialog } from '../../dialogs/CollectFunds.mjs';
import { JumpTo_getInstance3ru9x2o8nieur as JumpTo_getInstance } from '../../../utils/JumpTo.mjs';
import { get_pageNavigator1inl9j7ja0vlf as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import {
  first58ocm7j58k3q as first,
  withIndex37cl61h9v5txo as withIndex,
  toList3jhuyej2anx2q as toList,
  sortedWith2csnbbb21k0lg as sortedWith,
  distinct10qe1scfdvu5k as distinct,
  joinToString1cxrrlmo0chqs as joinToString,
  toSet2orjxp16sotqu as toSet,
  filterNotNull3qfgcwmxhwfxe as filterNotNull,
  max2o8z1isrnjymo as max,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ContractorProject2o386x7rid4t as ContractorProject } from './ContractorProject.mjs';
import { awaitNotNullzd1xp1uu2voc as awaitNotNull } from '../../../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import {
  get_rawSession1kjo1nj4tz6n0 as get_rawSession,
  get_session9cytjmfbg8nd as get_session,
} from '../../../sdk/UserSession.mjs';
import {
  get_selectedContractor2m4vxuqdzv6k3 as get_selectedContractor,
  get_notNullContractorsjk9enub7uol as get_notNullContractor,
} from '../../../selectedContractor.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { delay1diib1rb84y4j as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import {
  toString30pk9tzaqopn as toString,
  arrayOf1akklvh2at202 as arrayOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  Projecto73xqbcrzskm as Project,
  ProjectLedgerItem1yul4cns1huli as ProjectLedgerItem,
  LineItem2rt64afaiyloc as LineItem,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get_contractor2weo1umt9id6t as get_contractor } from '../../../../../../crowpay-shared/com/crowpay/ProjectFields.mjs';
import {
  eq1298m2cje971u as eq,
  inside3oxyfk5qky4sm as inside,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../theming/colorManagement.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  body3i5t0n7zprpqb as body,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  title1ahgushtajx2d as title,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  bodyBold2czwdzwknab0k as bodyBold,
  title1nssp3ryhwuqj as title_0,
  smallBody2trfy14zwtona as smallBody,
  centeredBody28evt7zh2q8en as centeredBody,
} from '../../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  FinanceTableSemantic_getInstance2sirlds87craf as FinanceTableSemantic_getInstance,
  renderContractorPaymentTable2wgebbq97b8wg as renderContractorPaymentTable,
  ProjectContractorPayments2a1bksdtdzr6w as ProjectContractorPayments,
} from './AvailableFunds.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance,
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
  AffirmativeSemantic_getInstance3qy0l8mucaq7h as AffirmativeSemantic_getInstance,
  ListSemantic_getInstance1hx6c2zatma42 as ListSemantic_getInstance,
  HeaderSemantic_getInstance39z1p9hszg7wp as HeaderSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { get_textButtonybbt8y3eu5hx as get_textButton } from '../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
  forEachById3ln6mzh4mndq4 as forEachById,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  _MonetaryValue___get_absoluteValue__impl__hjldkw3vj23mkf30f7c as _MonetaryValue___get_absoluteValue__impl__hjldkw,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  DirectStatus_Verified_getInstancew10gjsxm5l1j as DirectStatus_Verified_getInstance,
  AdminVerification_Verified_getInstance2j4n83c8vxcj0 as AdminVerification_Verified_getInstance,
  AdminVerification_Rejected_getInstance34sgzpx9e5upn as AdminVerification_Rejected_getInstance,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
  MonetaryValue__toStringAbsolute_impl_uovmiublgrzadk0gpl as MonetaryValue__toStringAbsolute_impl_uovmiu,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  compareValues1n2ayl87ihzfk as compareValues,
  compareBy2697bq0ffft96 as compareBy,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  LateInitSignal30crwrg540xyy as LateInitSignal,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  get_project24re8n4hoe63y as get_project,
  get_partyq13c2hdc8rqy as get_party,
  get_created3mwbwy01g8dq as get_created,
} from '../../../../../../crowpay-shared/com/crowpay/ProjectLedgerItemFields.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  Party_Contractor_getInstance2xfvwqnp35yxn as Party_Contractor_getInstance,
  PaymentState_AwaitingConfirmation_getInstance3vwisicrp8je as PaymentState_AwaitingConfirmation_getInstance,
  PaymentState_Succeeded_getInstance182gjb10iikdv as PaymentState_Succeeded_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { andvtrcuje7baox as and } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import {
  get__id219tqyp0nxml1 as get__id,
  get_created1jpxpz5eqbezu as get_created_0,
} from '../../../../../../crowpay-shared/com/crowpay/LineItemFields.mjs';
import {
  get_lightSection4cpu8okr0w14 as get_lightSection,
  LightSection_getInstance1p9fz392synu9 as LightSection_getInstance,
} from '../../theming/sections.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import { ReactiveContextSuspending39biijty1bpc5 as ReactiveContextSuspending } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContextSuspending.mjs';
import { Key_instance6wd16m35aua5 as Key_instance } from '../../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import {
  get_bold1rri6ahk98puv as get_bold,
  get_compact3lsezez8nz8b6 as get_compact,
  dynamicThemexp3sdnaolntz as dynamicTheme,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  NothingHereSemantic_getInstance3tro8v94k1jgs as NothingHereSemantic_getInstance,
  get_outlinedfhcs63de0vzu as get_outlined,
} from '../../theming/appTheme.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { toList2zksu85ukrmi as toList_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Maps.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import {
  RenderSize_Numerical_getInstance1z6x2shksihh7 as RenderSize_Numerical_getInstance,
  renderToString1atd3jbop96tk as renderToString,
  renderDateToString2ahaatg50tfe4 as renderDateToString,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import { keyString2ezqnhf3jck9c as keyString } from '../../components/keyValue.mjs';
import { DisplayableStateSemantic2q119ycceacla as DisplayableStateSemantic } from '../../theming/states.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { trackWeights2d4yjn3jzod5x as trackWeights } from '../../../utils/tables/ColumnWeights.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = rerunOn($this.ujg_1.ijf_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.ujg_1.ngl($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  var tmp = $this.vjg_1.yi7($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.wjg_1.mjf();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$0 = tmp_0;
  tmp.zgd(new (CollectFundsThroughDirectDepositDialog())(tmp$ret$0.p9v_1, $this.wjg_1));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.xjg_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var payments = tmp;
  JumpTo_getInstance().ng3_1.rg4();
  var tmp_0 = get_pageNavigator($this.yjg_1);
  var tmp0_safe_receiver = payments.zjd_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v7a_1;
  tmp_0.fbw(new (ContractorProject())(tmp1_elvis_lhs == null ? first(payments.aje_1).o7k_1 : tmp1_elvis_lhs));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.zjg_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var payments = tmp;
  JumpTo_getInstance().ng3_1.rg4();
  var tmp_0 = get_pageNavigator($this.ajh_1);
  var tmp0_safe_receiver = payments.zjd_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v7a_1;
  tmp_0.fbw(new (ContractorProject())(tmp1_elvis_lhs == null ? first(payments.aje_1).o7k_1 : tmp1_elvis_lhs));
  return Unit_instance;
}
function *_generator_retrievePaymentPendingCash__nq3rdk($this, $completion) {
  $this.mjf().uaq();
  var tmp = awaitNotNull($this.hgl(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var c = tmp;
  var tmp_0 = awaitNotNull(get_rawSession(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.vfw().off_1.tfi(c.t5i_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var result = tmp_1;
  var tmp_2 = $this.mjf().iah(result, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
function *_generator_retrievePaymentInfo__nex0l8($this, $completion) {
  $this.fi8().uaq();
  var tmp = awaitNotNull($this.hgl(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var c = tmp;
  var tmp_0 = awaitNotNull(get_rawSession(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.vfw().off_1.sfi(c.t5i_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var result = tmp_1;
  var tmp_2 = $this.fi8().iah(result, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
function *_generator_requestDirectDepositCashOut__u97bgf($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_selectedContractor();
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var id = tmp;
  if (!(id == null)) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_session();
    var tmp_0 = await_0(this_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp_1 = tmp_0.vfw().off_1.ufi(id, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  $this.mjf().uaq();
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var tmp$ret$2 = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
  var tmp_2 = delay(tmp$ret$2, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = $this.ngl($completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
var LedgerWithProjectClass;
function LedgerWithProject() {
  if (LedgerWithProjectClass === VOID) {
    class $ {
      constructor(ledger, project) {
        this.bjh_1 = ledger;
        this.cjh_1 = project;
      }
      toString() {
        return 'LedgerWithProject(ledger=' + this.bjh_1.toString() + ', project=' + toString(this.cjh_1) + ')';
      }
      hashCode() {
        var result = this.bjh_1.hashCode();
        result = imul(result, 31) + (this.cjh_1 == null ? 0 : this.cjh_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LedgerWithProject()))
          return false;
        if (!this.bjh_1.equals(other.bjh_1))
          return false;
        if (!equals(this.cjh_1, other.cjh_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'LedgerWithProject');
    LedgerWithProjectClass = $;
  }
  return LedgerWithProjectClass;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.djh_1 = function_0;
      }
      wi(a, b) {
        return this.djh_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.djh_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function ContractorPaymentInfo$_get_contractor_$lambda_mxzi6o($this$remember) {
  return ensureNotNull($this$remember.daj($this$remember.daj(get_session()).lfv_1.geo($this$remember.daj(get_notNullContractor()))));
}
function ContractorPaymentInfo$projects$lambda($this$remember) {
  var session = $this$remember.daj(get_session());
  var tmp0_elvis_lhs = $this$remember.daj(session.rfw_1).k88_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.collections.listOf' call
    return emptyList();
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var membership = tmp;
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$1);
  var tmp$ret$5 = eq(get_contractor(it), membership.g8c_1);
  return $this$remember.daj(session.rfv_1.heo(new (Query())(tmp$ret$5, VOID, VOID, 2147483647)));
}
function ContractorPaymentInfo$ledgerItemCount$lambda(it) {
  return it.p1();
}
var ContractorPaymentInfo$availableFundsCard$slambdaClass;
function ContractorPaymentInfo$availableFundsCard$slambda() {
  if (ContractorPaymentInfo$availableFundsCard$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.ujg_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorPaymentInfo$availableFundsCard$slambdaClass = $;
  }
  return ContractorPaymentInfo$availableFundsCard$slambdaClass;
}
function ContractorPaymentInfo$availableFundsCard$slambda_0(this$0) {
  var i = new (ContractorPaymentInfo$availableFundsCard$slambda())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var ContractorPaymentInfo$availableFundsCard$slambdaClass_0;
function ContractorPaymentInfo$availableFundsCard$slambda_1() {
  if (ContractorPaymentInfo$availableFundsCard$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.vjg_1 = this$0;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorPaymentInfo$availableFundsCard$slambdaClass_0 = $;
  }
  return ContractorPaymentInfo$availableFundsCard$slambdaClass_0;
}
function ContractorPaymentInfo$availableFundsCard$slambda_2(this$0) {
  var i = new (ContractorPaymentInfo$availableFundsCard$slambda_1())(this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var ContractorPaymentInfo$availableFundsCard$slambdaClass_1;
function ContractorPaymentInfo$availableFundsCard$slambda_3() {
  if (ContractorPaymentInfo$availableFundsCard$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.wjg_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorPaymentInfo$availableFundsCard$slambdaClass_1 = $;
  }
  return ContractorPaymentInfo$availableFundsCard$slambdaClass_1;
}
function ContractorPaymentInfo$availableFundsCard$slambda_4(this$0) {
  var i = new (ContractorPaymentInfo$availableFundsCard$slambda_3())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function ContractorPaymentInfo$newAvailableFundsTable$lambda(it) {
  var tmp0_safe_receiver = it.zjd_1;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v7a_1;
}
function ContractorPaymentInfo$newAvailableFundsTable$lambda_0($this$forEachById, payments) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$forEachById.pc());
  var tmp0_elvis_lhs = $this$forEachById.ebb_1;
  var p = tmp0_elvis_lhs == null ? $this$forEachById : tmp0_elvis_lhs;
  $this$forEachById.gbb(p, view);
  view.zbm(true);
  view.bb9(get_rem(0.5));
  var tmp = colored(view, AppColors_getInstance().efz_1.zg9_1);
  // Inline function 'com.crowpay.views.theming.boldSubTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.lba(view_0.qb6_1.abf(SubtitleSemantic_getInstance().abf(BoldSemantic_getInstance())));
  var tmp_0 = KMutableProperty0();
  var tmp_1 = TextView$_get_content_$ref_4pzcwl_1(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_1(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    var tmp0_safe_receiver = $this$reactiveScope.daj(payments).zjd_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b7b_1;
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 'No Project Found' : tmp1_elvis_lhs;
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  view.hbb(p_0, view_0);
  view.lbb(tmp, view_0);
  var tmp_2 = view.jbb(FinanceTableSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_1 = view.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.gbb(p_1, view_1);
  view_1.zbm(true);
  var tmp_3 = KMutableProperty0();
  var tmp_4 = RowOrCol$_get_gap_$ref_6ia4fr(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('gap', 0, tmp_3, tmp_4, RowOrCol$_set_gap_$ref_j3y5x9(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    var tmp$ret$7 = new (Dimension())(($this$reactiveScope.daj(payments).aje_1.p1() % 2 | 0) === 0 ? get_px(0) : get_px(3));
    this_1.set(tmp$ret$7);
    return Unit_instance;
  });
  renderContractorPaymentTable(view_1, payments);
  // Inline function 'com.lightningkite.kiteui.views.card' call
  var tmp_5 = view_1.jbb(CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_2.zbm(false);
  var tmp_6 = get_textButton(view_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Button())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.gbb(p_3, view_3);
  body(view_3, 'View Ledger');
  onClick(view_3, VOID, VOID, ContractorPaymentInfo$newAvailableFundsTable$lambda$slambda_0(payments, view_3));
  view_2.hbb(p_3, view_3);
  view_2.lbb(tmp_6, view_3);
  var tmp_7 = get_expanding(view_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (Space())(view_2.pc());
  var tmp0_elvis_lhs_4 = view_2.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
  view_2.gbb(p_4, view_4);
  view_2.hbb(p_4, view_4);
  view_2.lbb(tmp_7, view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_5 = view_2.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_2 : tmp0_elvis_lhs_5;
  view_2.gbb(p_5, view_5);
  view_5.zbm(false);
  view_5.lbb(get_centered(view_5), body(view_5, 'Available to Transfer'));
  var tmp_8 = get_centered(view_5);
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (TextView())(view_5.pc());
  var tmp0_elvis_lhs_6 = view_5.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
  view_5.gbb(p_6, view_6);
  view_6.lba(view_6.qb6_1.abf(BodySemantic_getInstance().abf(BoldSemantic_getInstance())));
  var tmp_9 = KMutableProperty0();
  var tmp_10 = TextView$_get_content_$ref_4pzcwl_2(view_6);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb_2(view_6));
  reactiveScope(view_6, ($this$reactiveScope) => {
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_0 = $this$reactiveScope.daj(payments).aje_1;
    var sum = Companion_instance.r91(0n);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp_0 = _MonetaryValue___get_absoluteValue__impl__hjldkw(element.s7k_1);
      var tmp0_elvis_lhs = element.t7k_1;
      var tmp_1;
      var tmp_2 = tmp0_elvis_lhs;
      if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
        tmp_1 = Companion_instance.m62(0);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var tmp$ret$16 = MonetaryValue__minus_impl_jw9qyp(tmp_0, tmp_1);
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$16);
    }
    var tmp$ret$17 = sum;
    var tmp$ret$18 = MonetaryValue__toString_impl_xslc77(tmp$ret$17);
    this_2.set(tmp$ret$18);
    return Unit_instance;
  });
  view_5.hbb(p_6, view_6);
  view_5.lbb(tmp_8, view_6);
  view_2.hbb(p_5, view_5);
  view_1.hbb(p_2, view_2);
  view_1.lbb(tmp_5, view_2);
  view.hbb(p_1, view_1);
  view.lbb(tmp_2, view_1);
  $this$forEachById.hbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function RowOrCol$_get_gap_$ref_6ia4fr(p0) {
  return () => {
    var tmp = p0.db9();
    return tmp == null ? null : new (Dimension())(tmp);
  };
}
function RowOrCol$_set_gap_$ref_j3y5x9(p0) {
  return (_this__u8e3s4) => {
    var tmp = _this__u8e3s4;
    p0.bb9(tmp == null ? null : tmp.yb1_1);
    return Unit_instance;
  };
}
var ContractorPaymentInfo$newAvailableFundsTable$lambda$slambdaClass;
function ContractorPaymentInfo$newAvailableFundsTable$lambda$slambda() {
  if (ContractorPaymentInfo$newAvailableFundsTable$lambda$slambdaClass === VOID) {
    class $ {
      constructor($payments, $$this$button) {
        this.xjg_1 = $payments;
        this.yjg_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorPaymentInfo$newAvailableFundsTable$lambda$slambdaClass = $;
  }
  return ContractorPaymentInfo$newAvailableFundsTable$lambda$slambdaClass;
}
function ContractorPaymentInfo$newAvailableFundsTable$lambda$slambda_0($payments, $$this$button) {
  var i = new (ContractorPaymentInfo$newAvailableFundsTable$lambda$slambda())($payments, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function ContractorPaymentInfo$paymentHistoryTable$lambda(it) {
  var tmp0_safe_receiver = it.zjd_1;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v7a_1;
}
function ContractorPaymentInfo$paymentHistoryTable$lambda_0($this$forEachById, payments) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$forEachById.pc());
  var tmp0_elvis_lhs = $this$forEachById.ebb_1;
  var p = tmp0_elvis_lhs == null ? $this$forEachById : tmp0_elvis_lhs;
  $this$forEachById.gbb(p, view);
  view.zbm(true);
  view.bb9(get_rem(0.5));
  var tmp = colored(view, AppColors_getInstance().efz_1.zg9_1);
  // Inline function 'com.crowpay.views.theming.boldSubTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.lba(view_0.qb6_1.abf(SubtitleSemantic_getInstance().abf(BoldSemantic_getInstance())));
  var tmp_0 = KMutableProperty0();
  var tmp_1 = TextView$_get_content_$ref_4pzcwl_3(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_3(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    var tmp0_safe_receiver = $this$reactiveScope.daj(payments).zjd_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b7b_1;
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 'No Project Found' : tmp1_elvis_lhs;
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  view.hbb(p_0, view_0);
  view.lbb(tmp, view_0);
  var tmp_2 = view.jbb(FinanceTableSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_1 = view.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.gbb(p_1, view_1);
  view_1.zbm(true);
  var tmp_3 = KMutableProperty0();
  var tmp_4 = RowOrCol$_get_gap_$ref_6ia4fr_0(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('gap', 0, tmp_3, tmp_4, RowOrCol$_set_gap_$ref_j3y5x9_0(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    var tmp$ret$7 = new (Dimension())(($this$reactiveScope.daj(payments).aje_1.p1() % 2 | 0) === 0 ? get_px(0) : get_px(3));
    this_1.set(tmp$ret$7);
    return Unit_instance;
  });
  renderContractorPaymentTable(view_1, payments);
  // Inline function 'com.lightningkite.kiteui.views.card' call
  var tmp_5 = view_1.jbb(CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_2.zbm(false);
  var tmp_6 = get_textButton(view_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Button())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.gbb(p_3, view_3);
  body(view_3, 'View Ledger');
  onClick(view_3, VOID, VOID, ContractorPaymentInfo$paymentHistoryTable$lambda$slambda_0(payments, view_3));
  view_2.hbb(p_3, view_3);
  view_2.lbb(tmp_6, view_3);
  var tmp_7 = get_expanding(view_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (Space())(view_2.pc());
  var tmp0_elvis_lhs_4 = view_2.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
  view_2.gbb(p_4, view_4);
  view_2.hbb(p_4, view_4);
  view_2.lbb(tmp_7, view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_5 = view_2.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_2 : tmp0_elvis_lhs_5;
  view_2.gbb(p_5, view_5);
  view_5.zbm(false);
  view_5.lbb(get_centered(view_5), body(view_5, 'Net Payment'));
  var tmp_8 = get_centered(view_5);
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (TextView())(view_5.pc());
  var tmp0_elvis_lhs_6 = view_5.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
  view_5.gbb(p_6, view_6);
  view_6.lba(view_6.qb6_1.abf(BodySemantic_getInstance().abf(BoldSemantic_getInstance())));
  var tmp_9 = KMutableProperty0();
  var tmp_10 = TextView$_get_content_$ref_4pzcwl_4(view_6);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb_4(view_6));
  reactiveScope(view_6, ($this$reactiveScope) => {
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_0 = $this$reactiveScope.daj(payments).aje_1;
    var sum = Companion_instance.r91(0n);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp_0 = _MonetaryValue___get_absoluteValue__impl__hjldkw(element.s7k_1);
      var tmp0_elvis_lhs = element.t7k_1;
      var tmp_1;
      var tmp_2 = tmp0_elvis_lhs;
      if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
        tmp_1 = Companion_instance.m62(0);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var tmp$ret$16 = MonetaryValue__minus_impl_jw9qyp(tmp_0, tmp_1);
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$16);
    }
    var tmp$ret$17 = sum;
    var tmp$ret$18 = MonetaryValue__toString_impl_xslc77(tmp$ret$17);
    this_2.set(tmp$ret$18);
    return Unit_instance;
  });
  view_5.hbb(p_6, view_6);
  view_5.lbb(tmp_8, view_6);
  view_2.hbb(p_5, view_5);
  view_1.hbb(p_2, view_2);
  view_1.lbb(tmp_5, view_2);
  view.hbb(p_1, view_1);
  view.lbb(tmp_2, view_1);
  $this$forEachById.hbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function RowOrCol$_get_gap_$ref_6ia4fr_0(p0) {
  return () => {
    var tmp = p0.db9();
    return tmp == null ? null : new (Dimension())(tmp);
  };
}
function RowOrCol$_set_gap_$ref_j3y5x9_0(p0) {
  return (_this__u8e3s4) => {
    var tmp = _this__u8e3s4;
    p0.bb9(tmp == null ? null : tmp.yb1_1);
    return Unit_instance;
  };
}
var ContractorPaymentInfo$paymentHistoryTable$lambda$slambdaClass;
function ContractorPaymentInfo$paymentHistoryTable$lambda$slambda() {
  if (ContractorPaymentInfo$paymentHistoryTable$lambda$slambdaClass === VOID) {
    class $ {
      constructor($payments, $$this$button) {
        this.zjg_1 = $payments;
        this.ajh_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorPaymentInfo$paymentHistoryTable$lambda$slambdaClass = $;
  }
  return ContractorPaymentInfo$paymentHistoryTable$lambda$slambdaClass;
}
function ContractorPaymentInfo$paymentHistoryTable$lambda$slambda_0($payments, $$this$button) {
  var i = new (ContractorPaymentInfo$paymentHistoryTable$lambda$slambda())($payments, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function ContractorPaymentInfo$transferHistoryTable$lambda$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.af_1.af_1;
  var tmp$ret$1 = a.af_1.af_1;
  return compareValues(tmp, tmp$ret$1);
}
function ContractorPaymentInfo$transferHistoryTable$lambda$lambda(it) {
  return it.af_1;
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_6(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_6(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function RowOrCol$_get_gap_$ref_6ia4fr_1(p0) {
  return () => {
    var tmp = p0.db9();
    return tmp == null ? null : new (Dimension())(tmp);
  };
}
function RowOrCol$_set_gap_$ref_j3y5x9_1(p0) {
  return (_this__u8e3s4) => {
    var tmp = _this__u8e3s4;
    p0.bb9(tmp == null ? null : tmp.yb1_1);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_7(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_7(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function ContractorPaymentInfo$transferHistoryTable$lambda$lambda$lambda$lambda(it) {
  var tmp0_safe_receiver = it.cjh_1;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v7a_1;
}
function ContractorPaymentInfo$transferHistoryTable$lambda$lambda$lambda$lambda_0(it) {
  return it.bjh_1.p7k_1;
}
function ContractorPaymentInfo$transferHistoryTable$lambda$lambda$lambda$lambda_1(it) {
  return it.bjh_1.n7k_1;
}
function ContractorPaymentInfo$transferHistoryTable$lambda$lambda$lambda_0(it) {
  return it.ml_1.bjh_1.n7k_1;
}
function ContractorPaymentInfo$transferHistoryTable$lambda$lambda$lambda$lambda_2(it) {
  return it.ll_1;
}
function ContractorPaymentInfo$transferHistoryTable$lambda$lambda$lambda$lambda_3(it) {
  return it.ml_1.cjh_1;
}
function ContractorPaymentInfo$transferHistoryTable$lambda$lambda$lambda$lambda_4(it) {
  return it.ml_1.bjh_1;
}
function TextView$_get_content_$ref_4pzcwl_8(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_8(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_9(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_9(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_10(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_10(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_11(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_11(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_12(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_12(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_13(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_13(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_14(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_14(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_15(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_15(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function ContractorPaymentInfo$billingHistoryTable$lambda$lambda(it) {
  return toList(withIndex(it));
}
function ContractorPaymentInfo$billingHistoryTable$lambda$lambda_0(it) {
  return it.ml_1.bjh_1.n7k_1;
}
function ContractorPaymentInfo$billingHistoryTable$lambda$lambda$lambda(it) {
  return it.ml_1.bjh_1;
}
function TextView$_get_content_$ref_4pzcwl_16(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_16(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_17(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_17(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_18(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_18(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var ContractorPaymentInfoClass;
function ContractorPaymentInfo() {
  if (ContractorPaymentInfoClass === VOID) {
    class $ {
      constructor() {
        this.cjf_1 = null;
        this.djf_1 = LateInitSignal().taq();
        this.ejf_1 = LateInitSignal().taq();
        var tmp = this;
        tmp.fjf_1 = remember(VOID, VOID, VOID, ContractorPaymentInfo$projects$lambda);
        this.gjf_1 = 20;
        this.hjf_1 = Signal().hak(0);
        var tmp_0 = this;
        tmp_0.ijf_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).sfv_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ProjectLedgerItem()), arrayOf([]), false));
          var tmp$ret$0 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$0);
          var tmp_1 = get_project(it);
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$remember.daj(this.fjf_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            var tmp$ret$2 = item.v7a_1;
            destination.v(tmp$ret$2);
          }
          var tmp_2 = and(inside(tmp_1, destination), eq(get_party(it), Party_Contractor_getInstance()));
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_1 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_3 = serializerOrContextual(createKType(getKClass(ProjectLedgerItem()), arrayOf([]), false));
          var tmp$ret$8 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$8);
          this_1.l4a(get_created(it_0));
          var tmp$ret$13 = this_1.m1r();
          return $this$remember.daj(tmp.mdw(new (Query())(tmp_2, tmp$ret$13, VOID, 5000)));
        });
        var tmp_1 = this;
        tmp_1.jjf_1 = lens(this.ijf_1, ContractorPaymentInfo$ledgerItemCount$lambda);
        var tmp_2 = this;
        tmp_2.kjf_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).ofv_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
          var tmp$ret$14 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$14);
          var tmp_1 = get__id(it);
          // Inline function 'kotlin.collections.mapNotNull' call
          var tmp0 = $this$remember.daj(this.ijf_1);
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var destination = ArrayList().w();
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp0_safe_receiver = element.p7k_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              destination.v(tmp0_safe_receiver);
            }
          }
          var tmp_2 = inside(tmp_1, destination);
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_3 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
          var tmp$ret$26 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$26);
          this_0.l4a(get_created_0(it_0));
          var tmp$ret$31 = this_0.m1r();
          return $this$remember.daj(tmp.mdw(new (Query())(tmp_2, tmp$ret$31, VOID, 2147483647)));
        });
      }
      hgl() {
        var tmp0_elvis_lhs = this.cjf_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this;
          tmp_0.cjf_1 = remember(VOID, VOID, VOID, ContractorPaymentInfo$_get_contractor_$lambda_mxzi6o);
          tmp = ensureNotNull(this.cjf_1);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      mjf() {
        return this.djf_1;
      }
      fi8() {
        return this.ejf_1;
      }
      ngl($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_retrievePaymentPendingCash__nq3rdk.bind(VOID, this), $completion);
      }
      yi7($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_retrievePaymentInfo__nex0l8.bind(VOID, this), $completion);
      }
      bi8($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_requestDirectDepositCashOut__u97bgf.bind(VOID, this), $completion);
      }
      ejh(_this__u8e3s4) {
        var tmp = get_lightSection(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        view.bb9(get_AppDimensions().zg1_1);
        // Inline function 'com.lightningkite.reactive.context.reactiveSuspending' call
        var action = ContractorPaymentInfo$availableFundsCard$slambda_0(this);
        // Inline function 'kotlin.also' call
        var this_0 = new (ReactiveContextSuspending())(view, VOID, VOID, action);
        this_0.aaj();
        var tmp0_safe_receiver = view.ga2().cd(Key_instance);
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.eah(this_0);
        }
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Space())(view_0.pc(), 0.0);
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_0.hbb(p_1, view_1);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content = 'Available Funds';
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (TextView())(view_0.pc());
        var tmp0_elvis_lhs_2 = view_0.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
        view_0.gbb(p_2, view_2);
        view_2.lba(view_2.qb6_1.abf(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_0 = view_2.vb5_1;
        var tmp_1;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content) === 0) {
          tmp_1 = '\xA0';
        } else {
          tmp_1 = content;
        }
        tmp_0.hbu(tmp_1);
        view_0.hbb(p_2, view_2);
        var tmp_2 = view_0.kbb(colored(view_0, AppColors_getInstance().ffz_1.zg9_1), get_bold(view_0));
        view_0.lbb(tmp_2, title(view_0, ($this$title) => {
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl($this$title);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb($this$title));
          reactiveScope($this$title, ($this$reactiveScope) => {
            var tmp$ret$12 = MonetaryValue__toString_impl_xslc77($this$reactiveScope.daj(this.mjf()).p9v_1);
            this_0.set(tmp$ret$12);
            return Unit_instance;
          });
          return Unit_instance;
        }));
        launch(view_0, VOID, VOID, ContractorPaymentInfo$availableFundsCard$slambda_2(this));
        var paymentVerified = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0_elvis_lhs = $this$remember.daj(this.fi8());
          var tmp;
          if (tmp0_elvis_lhs == null) {
            return false;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var p = tmp;
          var tmp_0;
          if (p.c9u_1.equals(AdminVerification_Verified_getInstance())) {
            var tmp1_safe_receiver = p.a9u_1;
            tmp_0 = equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e9v_1, DirectStatus_Verified_getInstance());
          } else {
            tmp_0 = false;
          }
          return tmp_0;
        });
        var tmp_3 = shownWhen(view_0, VOID, ($this$shownWhen) => !$this$shownWhen.daj(paymentVerified));
        // Inline function 'com.crowpay.views.theming.smallBody' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (TextView())(view_0.pc());
        var tmp0_elvis_lhs_3 = view_0.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
        view_0.gbb(p_3, view_3);
        view_3.lba(view_3.qb6_1.abf(SmallBodySemantic_getInstance()));
        var tmp_4 = KMutableProperty0();
        var tmp_5 = TextView$_get_content_$ref_4pzcwl_0(view_3);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_0(view_3));
        reactiveScope(view_3, ($this$reactiveScope) => {
          var p = $this$reactiveScope.daj(this.fi8());
          var tmp;
          var tmp_0;
          if ((p == null ? null : p.b9u_1) == null) {
            tmp_0 = true;
          } else {
            tmp_0 = p.a9u_1 == null;
          }
          if (tmp_0) {
            tmp = 'No account connected. Connect a bank account before collecting your funds';
          } else {
            var tmp1_safe_receiver = p.a9u_1;
            if (!equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e9v_1, DirectStatus_Verified_getInstance())) {
              tmp = "Your Bank Account isn't verified yet. Verify your account before collecting your funds";
            } else {
              if (p.c9u_1.equals(AdminVerification_Rejected_getInstance())) {
                tmp = 'You Bank Account has been rejected by Stoze.';
              } else {
                if (!p.c9u_1.equals(AdminVerification_Verified_getInstance())) {
                  tmp = "You Bank Account isn't approved by Stoze yet.";
                } else {
                  tmp = 'You cannot withdraw money at this time';
                }
              }
            }
          }
          var tmp$ret$14 = tmp;
          this_1.set(tmp$ret$14);
          return Unit_instance;
        });
        view_0.hbb(p_3, view_3);
        view_0.lbb(tmp_3, view_3);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var tmp_6 = view_0.jbb(ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.affirmative' call
        var tmp$ret$22 = view_0.jbb(AffirmativeSemantic_getInstance());
        var tmp_7 = view_0.kbb(tmp_6, tmp$ret$22);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (Button())(view_0.pc());
        var tmp0_elvis_lhs_4 = view_0.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
        view_0.gbb(p_4, view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
        var tmp0 = view_4.vb5_1.bb4_1;
        // Inline function 'com.lightningkite.kiteui.views.disabled' call
        var value = !false;
        tmp0.kb7_1.disabled = value;
        var tmp_8 = KMutableProperty0();
        var tmp_9 = Button$_get_enabled_$ref_61t7nx(view_4);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_2 = getPropertyCallableRef('enabled', 0, tmp_8, tmp_9, Button$_set_enabled_$ref_o8kynz(view_4));
        reactiveScope(view_4, ($this$reactiveScope) => {
          var tmp$ret$25 = MonetaryValue__compareTo_impl_w7ul1r($this$reactiveScope.daj(this.mjf()).p9v_1, Companion_instance.r91(0n)) > 0 && $this$reactiveScope.daj(paymentVerified);
          this_2.set(tmp$ret$25);
          return Unit_instance;
        });
        view_4.lbb(get_centered(view_4), bodyBold(view_4, 'Collect Funds'));
        onClick(view_4, VOID, VOID, ContractorPaymentInfo$availableFundsCard$slambda_4(this));
        view_0.hbb(p_4, view_4);
        view_0.lbb(tmp_7, view_4);
        view.hbb(p_0, view_0);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
      fjh(_this__u8e3s4) {
        var tmp = get_lightSection(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        view.bb9(get_AppDimensions().lg2_1);
        var tmp_0 = get_compact(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        title_0(view_0, 'New Available Funds');
        smallBody(view_0, 'Stoze receives a 1% service charge');
        view.hbb(p_0, view_0);
        view.lbb(tmp_0, view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Space())(view.pc(), 0.5);
        var tmp0_elvis_lhs_1 = view.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.gbb(p_1, view_1);
        view.hbb(p_1, view_1);
        var filtered = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.daj(this.ijf_1);
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.w7k_1.equals(PaymentState_AwaitingConfirmation_getInstance())) {
              destination.v(element);
            }
          }
          return destination;
        });
        var byProject = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.groupBy' call
          var tmp0 = $this$remember.daj(filtered);
          // Inline function 'kotlin.collections.groupByTo' call
          var destination = LinkedHashMap().f6();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var key = element.o7k_1;
            // Inline function 'kotlin.collections.getOrPut' call
            var value = destination.p3(key);
            var tmp;
            if (value == null) {
              var answer = ArrayList().w();
              destination.s3(key, answer);
              tmp = answer;
            } else {
              tmp = value;
            }
            var list = tmp;
            list.v(element);
          }
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList().u(destination.p1());
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s_0 = destination.d2().m1();
          while (_iterator__ex2g4s_0.n1()) {
            var item = _iterator__ex2g4s_0.o1();
            // Inline function 'kotlin.collections.component1' call
            var pid = item.e2();
            // Inline function 'kotlin.collections.component2' call
            var ledgers = item.f2();
            // Inline function 'kotlin.collections.find' call
            var tmp0_0 = $this$remember.daj(this.fjf_1);
            var tmp$ret$19;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s_1 = tmp0_0.m1();
              while (_iterator__ex2g4s_1.n1()) {
                var element_0 = _iterator__ex2g4s_1.o1();
                if (element_0.v7a_1.equals(pid)) {
                  tmp$ret$19 = element_0;
                  break $l$block;
                }
              }
              tmp$ret$19 = null;
            }
            var tmp$ret$20 = tmp$ret$19;
            var tmp$ret$21 = new (ProjectContractorPayments())(tmp$ret$20, ledgers, $this$remember.daj(this.kjf_1));
            destination_0.v(tmp$ret$21);
          }
          return destination_0;
        });
        var tmp_1 = view.kbb(shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj(byProject).i1()), view.jbb(NothingHereSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_2 = view.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
        view.gbb(p_2, view_2);
        view_2.zbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Space())(view_2.pc(), 0.5);
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        view_2.hbb(p_3, view_3);
        // Inline function 'com.crowpay.views.theming.boldSubTitle' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (TextView())(view_2.pc());
        var tmp0_elvis_lhs_4 = view_2.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
        view_2.gbb(p_4, view_4);
        view_4.lba(view_4.qb6_1.abf(SubtitleSemantic_getInstance().abf(BoldSemantic_getInstance())));
        view_4.dbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value = 'Nothing Yet';
        var tmp_2 = view_4.vb5_1;
        var tmp_3;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value) === 0) {
          tmp_3 = '\xA0';
        } else {
          tmp_3 = value;
        }
        tmp_2.hbu(tmp_3);
        view_2.hbb(p_4, view_4);
        // Inline function 'com.crowpay.views.theming.smallBody' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (TextView())(view_2.pc());
        var tmp0_elvis_lhs_5 = view_2.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_2 : tmp0_elvis_lhs_5;
        view_2.gbb(p_5, view_5);
        view_5.lba(view_5.qb6_1.abf(SmallBodySemantic_getInstance()));
        view_5.dbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value_0 = 'When funds for work are released they will appear here';
        var tmp_4 = view_5.vb5_1;
        var tmp_5;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value_0) === 0) {
          tmp_5 = '\xA0';
        } else {
          tmp_5 = value_0;
        }
        tmp_4.hbu(tmp_5);
        view_2.hbb(p_5, view_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Space())(view_2.pc(), 0.5);
        var tmp0_elvis_lhs_6 = view_2.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_2 : tmp0_elvis_lhs_6;
        view_2.gbb(p_6, view_6);
        view_2.hbb(p_6, view_6);
        view.hbb(p_2, view_2);
        view.lbb(tmp_1, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_7 = view.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view : tmp0_elvis_lhs_7;
        view.gbb(p_7, view_7);
        view_7.zbm(true);
        view_7.bb9(get_rem_0(2));
        var tmp_6 = ContractorPaymentInfo$newAvailableFundsTable$lambda;
        forEachById(view_7, byProject, tmp_6, VOID, ContractorPaymentInfo$newAvailableFundsTable$lambda_0);
        view.hbb(p_7, view_7);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
      gjh(_this__u8e3s4) {
        var tmp = get_lightSection(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        view.bb9(get_AppDimensions().lg2_1);
        var tmp_0 = get_compact(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        title_0(view_0, 'Payment History');
        smallBody(view_0, 'Whenever funds for work are released for your collection they will appear here. Stoze receives a 1% service charge.');
        view.hbb(p_0, view_0);
        view.lbb(tmp_0, view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Space())(view.pc(), 0.5);
        var tmp0_elvis_lhs_1 = view.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.gbb(p_1, view_1);
        view.hbb(p_1, view_1);
        var byProject = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.groupBy' call
          var tmp0 = $this$remember.daj(this.ijf_1);
          // Inline function 'kotlin.collections.groupByTo' call
          var destination = LinkedHashMap().f6();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var key = element.o7k_1;
            // Inline function 'kotlin.collections.getOrPut' call
            var value = destination.p3(key);
            var tmp;
            if (value == null) {
              var answer = ArrayList().w();
              destination.s3(key, answer);
              tmp = answer;
            } else {
              tmp = value;
            }
            var list = tmp;
            list.v(element);
          }
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList().u(destination.p1());
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s_0 = destination.d2().m1();
          while (_iterator__ex2g4s_0.n1()) {
            var item = _iterator__ex2g4s_0.o1();
            // Inline function 'kotlin.collections.component1' call
            var pid = item.e2();
            // Inline function 'kotlin.collections.component2' call
            var ledgers = item.f2();
            // Inline function 'kotlin.collections.find' call
            var tmp0_0 = $this$remember.daj(this.fjf_1);
            var tmp$ret$16;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s_1 = tmp0_0.m1();
              while (_iterator__ex2g4s_1.n1()) {
                var element_0 = _iterator__ex2g4s_1.o1();
                if (element_0.v7a_1.equals(pid)) {
                  tmp$ret$16 = element_0;
                  break $l$block;
                }
              }
              tmp$ret$16 = null;
            }
            var tmp$ret$17 = tmp$ret$16;
            var tmp$ret$18 = new (ProjectContractorPayments())(tmp$ret$17, ledgers, $this$remember.daj(this.kjf_1));
            destination_0.v(tmp$ret$18);
          }
          return destination_0;
        });
        var tmp_1 = view.kbb(shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj(byProject).i1()), view.jbb(NothingHereSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_2 = view.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
        view.gbb(p_2, view_2);
        view_2.zbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Space())(view_2.pc(), 0.5);
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        view_2.hbb(p_3, view_3);
        // Inline function 'com.crowpay.views.theming.boldSubTitle' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (TextView())(view_2.pc());
        var tmp0_elvis_lhs_4 = view_2.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
        view_2.gbb(p_4, view_4);
        view_4.lba(view_4.qb6_1.abf(SubtitleSemantic_getInstance().abf(BoldSemantic_getInstance())));
        view_4.dbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value = 'Nothing Yet';
        var tmp_2 = view_4.vb5_1;
        var tmp_3;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value) === 0) {
          tmp_3 = '\xA0';
        } else {
          tmp_3 = value;
        }
        tmp_2.hbu(tmp_3);
        view_2.hbb(p_4, view_4);
        // Inline function 'com.crowpay.views.theming.smallBody' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (TextView())(view_2.pc());
        var tmp0_elvis_lhs_5 = view_2.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_2 : tmp0_elvis_lhs_5;
        view_2.gbb(p_5, view_5);
        view_5.lba(view_5.qb6_1.abf(SmallBodySemantic_getInstance()));
        view_5.dbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value_0 = 'When funds for work are released they will appear here';
        var tmp_4 = view_5.vb5_1;
        var tmp_5;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value_0) === 0) {
          tmp_5 = '\xA0';
        } else {
          tmp_5 = value_0;
        }
        tmp_4.hbu(tmp_5);
        view_2.hbb(p_5, view_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Space())(view_2.pc(), 0.5);
        var tmp0_elvis_lhs_6 = view_2.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_2 : tmp0_elvis_lhs_6;
        view_2.gbb(p_6, view_6);
        view_2.hbb(p_6, view_6);
        view.hbb(p_2, view_2);
        view.lbb(tmp_1, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_7 = view.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view : tmp0_elvis_lhs_7;
        view.gbb(p_7, view_7);
        view_7.zbm(true);
        view_7.bb9(get_rem_0(2));
        var tmp_6 = ContractorPaymentInfo$paymentHistoryTable$lambda;
        forEachById(view_7, byProject, tmp_6, VOID, ContractorPaymentInfo$paymentHistoryTable$lambda_0);
        view.hbb(p_7, view_7);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
      hjh(_this__u8e3s4) {
        var tmp = get_lightSection(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        var $this$col = view;
        trackWeights(($this$trackWeights) => {
          var tmp = get_compact($this$col);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          var this_0 = $this$col;
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())(this_0.pc());
          var tmp0_elvis_lhs = this_0.ebb_1;
          var p = tmp0_elvis_lhs == null ? this_0 : tmp0_elvis_lhs;
          this_0.gbb(p, view);
          view.zbm(true);
          title_0(view, 'Transfer History');
          smallBody(view, 'Summary of previous transfers');
          this_0.hbb(p, view);
          $this$col.lbb(tmp, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          var this_1 = $this$col;
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (Space())(this_1.pc(), 0.5);
          var tmp0_elvis_lhs_0 = this_1.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? this_1 : tmp0_elvis_lhs_0;
          this_1.gbb(p_0, view_0);
          this_1.hbb(p_0, view_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          var this_2 = $this$col;
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(this_2.pc());
          var tmp0_elvis_lhs_1 = this_2.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? this_2 : tmp0_elvis_lhs_1;
          this_2.gbb(p_1, view_1);
          view_1.zbm(true);
          var transfers = remember(VOID, VOID, VOID, ($this$remember) => {
            // Inline function 'kotlin.collections.filter' call
            var tmp0 = $this$remember.daj(this.ijf_1);
            // Inline function 'kotlin.collections.filterTo' call
            var destination = ArrayList().w();
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (!(element.a7l_1 == null)) {
                destination.v(element);
              }
            }
            return destination;
          });
          var grouped = remember(VOID, VOID, VOID, ($this$remember) => {
            // Inline function 'kotlin.collections.associateBy' call
            var this_0 = $this$remember.daj(this.fjf_1);
            var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
            // Inline function 'kotlin.collections.associateByTo' call
            var destination = LinkedHashMap().fc(capacity);
            var _iterator__ex2g4s = this_0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              var tmp$ret$10 = element.v7a_1;
              destination.s3(tmp$ret$10, element);
            }
            var projects = destination;
            // Inline function 'kotlin.collections.map' call
            var this_1 = $this$remember.daj(transfers);
            // Inline function 'kotlin.collections.mapTo' call
            var destination_0 = ArrayList().u(collectionSizeOrDefault(this_1, 10));
            var _iterator__ex2g4s_0 = this_1.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var item = _iterator__ex2g4s_0.o1();
              var tmp$ret$13 = new (LedgerWithProject())(item, projects.p3(item.o7k_1));
              destination_0.v(tmp$ret$13);
            }
            // Inline function 'kotlin.collections.groupBy' call
            // Inline function 'kotlin.collections.groupByTo' call
            var destination_1 = LinkedHashMap().f6();
            var _iterator__ex2g4s_1 = destination_0.m1();
            while (_iterator__ex2g4s_1.n1()) {
              var element_0 = _iterator__ex2g4s_1.o1();
              var key = to(element_0.bjh_1.a7l_1, element_0.bjh_1.y7k_1);
              // Inline function 'kotlin.collections.getOrPut' call
              var value = destination_1.p3(key);
              var tmp;
              if (value == null) {
                var answer = ArrayList().w();
                destination_1.s3(key, answer);
                tmp = answer;
              } else {
                tmp = value;
              }
              var list = tmp;
              list.v(element_0);
            }
            // Inline function 'kotlin.collections.sortedByDescending' call
            var this_2 = toList_0(destination_1);
            // Inline function 'kotlin.comparisons.compareByDescending' call
            var tmp_0 = ContractorPaymentInfo$transferHistoryTable$lambda$lambda$lambda;
            var tmp$ret$21 = new (sam$kotlin_Comparator$0())(tmp_0);
            return sortedWith(this_2, tmp$ret$21);
          });
          var tmp_0 = view_1.kbb(shownWhen(view_1, VOID, ($this$shownWhen) => $this$shownWhen.daj(grouped).i1()), view_1.jbb(NothingHereSemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (RowOrCol())(view_1.pc());
          var tmp0_elvis_lhs_2 = view_1.ebb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
          view_1.gbb(p_2, view_2);
          view_2.zbm(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (Space())(view_2.pc(), 0.5);
          var tmp0_elvis_lhs_3 = view_2.ebb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
          view_2.gbb(p_3, view_3);
          view_2.hbb(p_3, view_3);
          // Inline function 'com.crowpay.views.theming.boldSubTitle' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (TextView())(view_2.pc());
          var tmp0_elvis_lhs_4 = view_2.ebb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
          view_2.gbb(p_4, view_4);
          view_4.lba(view_4.qb6_1.abf(SubtitleSemantic_getInstance().abf(BoldSemantic_getInstance())));
          view_4.dbs(Align_Center_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var value = 'Nothing Yet';
          var tmp_1 = view_4.vb5_1;
          var tmp_2;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(value) === 0) {
            tmp_2 = '\xA0';
          } else {
            tmp_2 = value;
          }
          tmp_1.hbu(tmp_2);
          view_2.hbb(p_4, view_4);
          // Inline function 'com.crowpay.views.theming.smallBody' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (TextView())(view_2.pc());
          var tmp0_elvis_lhs_5 = view_2.ebb_1;
          var p_5 = tmp0_elvis_lhs_5 == null ? view_2 : tmp0_elvis_lhs_5;
          view_2.gbb(p_5, view_5);
          view_5.lba(view_5.qb6_1.abf(SmallBodySemantic_getInstance()));
          view_5.dbs(Align_Center_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var value_0 = 'Transfers will appear here when initiated';
          var tmp_3 = view_5.vb5_1;
          var tmp_4;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(value_0) === 0) {
            tmp_4 = '\xA0';
          } else {
            tmp_4 = value_0;
          }
          tmp_3.hbu(tmp_4);
          view_2.hbb(p_5, view_5);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_6 = new (Space())(view_2.pc(), 0.5);
          var tmp0_elvis_lhs_6 = view_2.ebb_1;
          var p_6 = tmp0_elvis_lhs_6 == null ? view_2 : tmp0_elvis_lhs_6;
          view_2.gbb(p_6, view_6);
          view_2.hbb(p_6, view_6);
          view_1.hbb(p_2, view_2);
          view_1.lbb(tmp_0, view_2);
          var tmp_5 = shownWhen(view_1, VOID, ($this$shownWhen) => {
            // Inline function 'kotlin.collections.isNotEmpty' call
            return !$this$shownWhen.daj(grouped).i1();
          });
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_7 = new (RowOrCol())(view_1.pc());
          var tmp0_elvis_lhs_7 = view_1.ebb_1;
          var p_7 = tmp0_elvis_lhs_7 == null ? view_1 : tmp0_elvis_lhs_7;
          view_1.gbb(p_7, view_7);
          view_7.zbm(true);
          var tmp_6 = ContractorPaymentInfo$transferHistoryTable$lambda$lambda;
          forEachById(view_7, grouped, tmp_6, VOID, ($this$forEachById, group) => {
            var status = remember(VOID, VOID, VOID, ($this$remember) => {
              // Inline function 'kotlin.collections.minOf' call
              var iterator = $this$remember.daj(group).bf_1.m1();
              if (!iterator.n1())
                throw NoSuchElementException().y1();
              var minValue = iterator.o1().bjh_1.w7k_1;
              while (iterator.n1()) {
                var v = iterator.o1().bjh_1.w7k_1;
                if (compareTo(minValue, v) > 0) {
                  minValue = v;
                }
              }
              return minValue;
            });
            // Inline function 'com.lightningkite.kiteui.views.direct.col' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view = new (RowOrCol())($this$forEachById.pc());
            var tmp0_elvis_lhs = $this$forEachById.ebb_1;
            var p = tmp0_elvis_lhs == null ? $this$forEachById : tmp0_elvis_lhs;
            $this$forEachById.gbb(p, view);
            view.zbm(true);
            view.bb9(get_rem(0.5));
            var tmp = get_compact(view);
            // Inline function 'com.lightningkite.kiteui.views.direct.col' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_0 = new (RowOrCol())(view.pc());
            var tmp0_elvis_lhs_0 = view.ebb_1;
            var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
            view.gbb(p_0, view_0);
            view_0.zbm(true);
            var tmp_0 = colored(view_0, AppColors_getInstance().efz_1.zg9_1);
            // Inline function 'com.crowpay.views.theming.boldSubTitle' call
            // Inline function 'com.lightningkite.kiteui.views.direct.text' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_1 = new (TextView())(view_0.pc());
            var tmp0_elvis_lhs_1 = view_0.ebb_1;
            var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
            view_0.gbb(p_1, view_1);
            view_1.lba(view_1.qb6_1.abf(SubtitleSemantic_getInstance().abf(BoldSemantic_getInstance())));
            var tmp_1 = KMutableProperty0();
            var tmp_2 = TextView$_get_content_$ref_4pzcwl_5(view_1);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb_5(view_1));
            reactiveScope(view_1, ($this$reactiveScope) => {
              var tmp0_safe_receiver = $this$reactiveScope.daj(group).af_1.af_1;
              var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : renderToString(tmp0_safe_receiver, RenderSize_Numerical_getInstance());
              var tmp$ret$51 = 'Transfer Initiated on ' + (tmp1_elvis_lhs == null ? '...' : tmp1_elvis_lhs);
              this_0.set(tmp$ret$51);
              return Unit_instance;
            });
            view_0.hbb(p_1, view_1);
            view_0.lbb(tmp_0, view_1);
            var tmp_3 = get_outlined(view_0);
            // Inline function 'com.lightningkite.kiteui.views.direct.col' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_2 = new (RowOrCol())(view_0.pc());
            var tmp0_elvis_lhs_2 = view_0.ebb_1;
            var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
            view_0.gbb(p_2, view_2);
            view_2.zbm(true);
            var tmp_4 = shownWhen(view_2, VOID, ($this$shownWhen) => $this$shownWhen.daj(status).equals(PaymentState_Succeeded_getInstance()));
            view_2.lbb(tmp_4, keyString(view_2, 'Account', ($this$keyString) => {
              // Inline function 'kotlin.collections.mapNotNull' call
              var tmp0 = $this$keyString.daj(group).bf_1;
              // Inline function 'kotlin.collections.mapNotNullTo' call
              var destination = ArrayList().w();
              // Inline function 'kotlin.collections.forEach' call
              var _iterator__ex2g4s = tmp0.m1();
              while (_iterator__ex2g4s.n1()) {
                var element = _iterator__ex2g4s.o1();
                var tmp0_safe_receiver = element.bjh_1.c7l_1;
                if (tmp0_safe_receiver == null)
                  null;
                else {
                  // Inline function 'kotlin.let' call
                  destination.v(tmp0_safe_receiver);
                }
              }
              return joinToString(distinct(destination));
            }));
            keyString(view_2, 'Method', ($this$keyString) => {
              // Inline function 'kotlin.collections.map' call
              var this_0 = $this$keyString.daj(group).bf_1;
              // Inline function 'kotlin.collections.mapTo' call
              var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
              var _iterator__ex2g4s = this_0.m1();
              while (_iterator__ex2g4s.n1()) {
                var item = _iterator__ex2g4s.o1();
                var tmp0_safe_receiver = item.bjh_1.y7k_1;
                var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f9l_1;
                var tmp$ret$65 = tmp1_elvis_lhs == null ? '2-3 Day' : tmp1_elvis_lhs;
                destination.v(tmp$ret$65);
              }
              return joinToString(distinct(destination));
            });
            // Inline function 'com.crowpay.views.components.keyView' call
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_3 = new (RowOrCol())(view_2.pc());
            var tmp0_elvis_lhs_3 = view_2.ebb_1;
            var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
            view_2.gbb(p_3, view_3);
            view_3.zbm(false);
            view_3.bb9(get_rem(0.5));
            bodyBold(view_3, 'Status' + ':');
            var tmp_5 = get_expanding(view_3);
            // Inline function 'com.lightningkite.kiteui.views.direct.text' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_4 = new (TextView())(view_3.pc());
            var tmp0_elvis_lhs_4 = view_3.ebb_1;
            var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
            view_3.gbb(p_4, view_4);
            dynamicTheme(view_4, ($this$dynamicTheme) => DisplayableStateSemantic().ogt($this$dynamicTheme.daj(status)));
            var tmp_6 = KMutableProperty0();
            var tmp_7 = TextView$_get_content_$ref_4pzcwl_6(view_4);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_1 = getPropertyCallableRef('content', 0, tmp_6, tmp_7, TextView$_set_content_$ref_pketfb_6(view_4));
            reactiveScope(view_4, ($this$reactiveScope) => {
              var tmp$ret$68 = $this$reactiveScope.daj(status).t9c_1;
              this_1.set(tmp$ret$68);
              return Unit_instance;
            });
            view_3.hbb(p_4, view_4);
            view_3.lbb(tmp_5, view_4);
            view_2.hbb(p_3, view_3);
            var succeeded = remember(VOID, VOID, VOID, ($this$remember) => {
              // Inline function 'kotlin.collections.map' call
              var this_0 = $this$remember.daj(group).bf_1;
              // Inline function 'kotlin.collections.mapTo' call
              var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
              var _iterator__ex2g4s = this_0.m1();
              while (_iterator__ex2g4s.n1()) {
                var item = _iterator__ex2g4s.o1();
                var tmp$ret$79 = item.bjh_1.b7l_1;
                destination.v(tmp$ret$79);
              }
              var confirmations = toSet(destination);
              var tmp;
              var tmp$ret$82;
              $l$block_0: {
                // Inline function 'kotlin.collections.any' call
                var tmp_0;
                if (isInterface(confirmations, Collection())) {
                  tmp_0 = confirmations.i1();
                } else {
                  tmp_0 = false;
                }
                if (tmp_0) {
                  tmp$ret$82 = false;
                  break $l$block_0;
                }
                var _iterator__ex2g4s_0 = confirmations.m1();
                while (_iterator__ex2g4s_0.n1()) {
                  var element = _iterator__ex2g4s_0.o1();
                  if (element == null) {
                    tmp$ret$82 = true;
                    break $l$block_0;
                  }
                }
                tmp$ret$82 = false;
              }
              if (tmp$ret$82) {
                tmp = null;
              } else {
                tmp = max(filterNotNull(confirmations));
              }
              return tmp;
            });
            var tmp_8 = shownWhen(view_2, VOID, ($this$shownWhen) => !($this$shownWhen.daj(succeeded) == null));
            view_2.lbb(tmp_8, keyString(view_2, 'Deposited', ($this$keyString) => {
              var tmp0_safe_receiver = $this$keyString.daj(succeeded);
              var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : renderToString(tmp0_safe_receiver, RenderSize_Numerical_getInstance());
              return tmp1_elvis_lhs == null ? '...' : tmp1_elvis_lhs;
            }));
            view_0.hbb(p_2, view_2);
            view_0.lbb(tmp_3, view_2);
            view.hbb(p_0, view_0);
            view.lbb(tmp, view_0);
            var tmp_9 = view.jbb(FinanceTableSemantic_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.direct.col' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_5 = new (RowOrCol())(view.pc());
            var tmp0_elvis_lhs_5 = view.ebb_1;
            var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
            view.gbb(p_5, view_5);
            view_5.zbm(true);
            var tmp_10 = KMutableProperty0();
            var tmp_11 = RowOrCol$_get_gap_$ref_6ia4fr_1(view_5);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_2 = getPropertyCallableRef('gap', 0, tmp_10, tmp_11, RowOrCol$_set_gap_$ref_j3y5x9_1(view_5));
            reactiveScope(view_5, ($this$reactiveScope) => {
              var tmp$ret$92 = new (Dimension())(($this$reactiveScope.daj(group).bf_1.p1() % 2 | 0) === 0 ? get_px(0) : get_px(3));
              this_2.set(tmp$ret$92);
              return Unit_instance;
            });
            var tmp_12 = view_5.jbb(ListSemantic_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.direct.col' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_6 = new (RowOrCol())(view_5.pc());
            var tmp0_elvis_lhs_6 = view_5.ebb_1;
            var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
            view_5.gbb(p_6, view_6);
            view_6.zbm(true);
            var tmp_13 = view_6.jbb(HeaderSemantic_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_7 = new (RowOrCol())(view_6.pc());
            var tmp0_elvis_lhs_7 = view_6.ebb_1;
            var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
            view_6.gbb(p_7, view_7);
            view_7.zbm(false);
            view_7.lbb(view_7.kbb(get_centered(view_7), $this$trackWeights.og6(view_7, 1.5)), body(view_7, 'PROJECT'));
            view_7.lbb(view_7.kbb(get_centered(view_7), $this$trackWeights.og6(view_7, 1.0)), centeredBody(view_7, 'FROM'));
            view_7.lbb(view_7.kbb(get_centered(view_7), $this$trackWeights.og6(view_7, 1.0)), centeredBody(view_7, 'SOURCE'));
            view_7.lbb(view_7.kbb(get_centered(view_7), $this$trackWeights.og6(view_7, 0.7)), centeredBody(view_7, 'AMOUNT'));
            view_7.lbb(view_7.kbb(get_centered(view_7), $this$trackWeights.og6(view_7, 0.7)), centeredBody(view_7, 'FEE'));
            var tmp_14 = view_7.kbb(get_centered(view_7), $this$trackWeights.og6(view_7, 0.7));
            // Inline function 'com.crowpay.views.theming.body' call
            // Inline function 'com.lightningkite.kiteui.views.direct.text' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_8 = new (TextView())(view_7.pc());
            var tmp0_elvis_lhs_8 = view_7.ebb_1;
            var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
            view_7.gbb(p_8, view_8);
            view_8.lba(view_8.qb6_1.abf(BodySemantic_getInstance()));
            view_8.dbs(Align_Center_getInstance());
            var tmp_15 = KMutableProperty0();
            var tmp_16 = TextView$_get_content_$ref_4pzcwl_7(view_8);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_3 = getPropertyCallableRef('content', 0, tmp_15, tmp_16, TextView$_set_content_$ref_pketfb_7(view_8));
            reactiveScope(view_8, ($this$reactiveScope) => {
              var tmp$ret$94 = $this$reactiveScope.daj(status).equals(PaymentState_Succeeded_getInstance()) ? 'DEPOSITED' : 'DEPOSIT';
              this_3.set(tmp$ret$94);
              return Unit_instance;
            });
            view_7.hbb(p_8, view_8);
            view_7.lbb(tmp_14, view_8);
            view_6.hbb(p_7, view_7);
            view_6.lbb(tmp_13, view_7);
            var tmp_17 = view_6.jbb(ListSemantic_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.direct.col' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_9 = new (RowOrCol())(view_6.pc());
            var tmp0_elvis_lhs_9 = view_6.ebb_1;
            var p_9 = tmp0_elvis_lhs_9 == null ? view_6 : tmp0_elvis_lhs_9;
            view_6.gbb(p_9, view_9);
            view_9.zbm(true);
            var tmp_18 = remember(VOID, VOID, VOID, ($this$remember) => {
              var tmp = $this$remember.daj(group).bf_1;
              var tmp_0 = ContractorPaymentInfo$transferHistoryTable$lambda$lambda$lambda$lambda;
              var tmp_1 = ContractorPaymentInfo$transferHistoryTable$lambda$lambda$lambda$lambda_0;
              return toList(withIndex(sortedWith(tmp, compareBy([tmp_0, tmp_1, ContractorPaymentInfo$transferHistoryTable$lambda$lambda$lambda$lambda_1]))));
            });
            var tmp_19 = ContractorPaymentInfo$transferHistoryTable$lambda$lambda$lambda_0;
            forEachById(view_9, tmp_18, tmp_19, VOID, ($this$forEachById, indexed) => {
              var idx = lens(indexed, ContractorPaymentInfo$transferHistoryTable$lambda$lambda$lambda$lambda_2);
              var project = lens(indexed, ContractorPaymentInfo$transferHistoryTable$lambda$lambda$lambda$lambda_3);
              var ledger = lens(indexed, ContractorPaymentInfo$transferHistoryTable$lambda$lambda$lambda$lambda_4);
              // Inline function 'com.lightningkite.kiteui.views.direct.row' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view = new (RowOrCol())($this$forEachById.pc());
              var tmp0_elvis_lhs = $this$forEachById.ebb_1;
              var p = tmp0_elvis_lhs == null ? $this$forEachById : tmp0_elvis_lhs;
              $this$forEachById.gbb(p, view);
              view.zbm(false);
              dynamicTheme(view, ($this$dynamicTheme) => ($this$dynamicTheme.daj(idx) % 2 | 0) === 0 ? CardSemantic_getInstance() : LightSection_getInstance());
              var tmp = view.kbb(get_centered(view), $this$trackWeights.pg6(view));
              // Inline function 'com.crowpay.views.theming.body' call
              // Inline function 'com.lightningkite.kiteui.views.direct.text' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_0 = new (TextView())(view.pc());
              var tmp0_elvis_lhs_0 = view.ebb_1;
              var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
              view.gbb(p_0, view_0);
              view_0.lba(view_0.qb6_1.abf(BodySemantic_getInstance()));
              var tmp_0 = KMutableProperty0();
              var tmp_1 = TextView$_get_content_$ref_4pzcwl_8(view_0);
              // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
              var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_8(view_0));
              reactiveScope(view_0, ($this$reactiveScope) => {
                var tmp0_safe_receiver = $this$reactiveScope.daj(project);
                var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b7b_1;
                var tmp$ret$105 = tmp1_elvis_lhs == null ? '...' : tmp1_elvis_lhs;
                this_0.set(tmp$ret$105);
                return Unit_instance;
              });
              view.hbb(p_0, view_0);
              view.lbb(tmp, view_0);
              var tmp_2 = view.kbb(get_centered(view), $this$trackWeights.pg6(view));
              // Inline function 'com.crowpay.views.theming.body' call
              // Inline function 'com.lightningkite.kiteui.views.direct.text' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_1 = new (TextView())(view.pc());
              var tmp0_elvis_lhs_1 = view.ebb_1;
              var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
              view.gbb(p_1, view_1);
              view_1.lba(view_1.qb6_1.abf(BodySemantic_getInstance()));
              view_1.dbs(Align_Center_getInstance());
              var tmp_3 = KMutableProperty0();
              var tmp_4 = TextView$_get_content_$ref_4pzcwl_9(view_1);
              // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
              var this_1 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb_9(view_1));
              reactiveScope(view_1, ($this$reactiveScope) => {
                var id = $this$reactiveScope.daj(ledger).p7k_1;
                var tmp;
                if (id == null) {
                  tmp = 'Project Completed';
                } else {
                  // Inline function 'kotlin.collections.find' call
                  var tmp0 = $this$reactiveScope.daj(this.kjf_1);
                  var tmp$ret$113;
                  $l$block_1: {
                    // Inline function 'kotlin.collections.firstOrNull' call
                    var _iterator__ex2g4s = tmp0.m1();
                    while (_iterator__ex2g4s.n1()) {
                      var element = _iterator__ex2g4s.o1();
                      if (element.e6k_1.equals(id)) {
                        tmp$ret$113 = element;
                        break $l$block_1;
                      }
                    }
                    tmp$ret$113 = null;
                  }
                  var tmp0_safe_receiver = tmp$ret$113;
                  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j6k_1;
                  tmp = tmp1_elvis_lhs == null ? '...' : tmp1_elvis_lhs;
                }
                var tmp$ret$115 = tmp;
                this_1.set(tmp$ret$115);
                return Unit_instance;
              });
              view.hbb(p_1, view_1);
              view.lbb(tmp_2, view_1);
              var tmp_5 = view.kbb(get_centered(view), $this$trackWeights.pg6(view));
              // Inline function 'com.crowpay.views.theming.body' call
              // Inline function 'com.lightningkite.kiteui.views.direct.text' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_2 = new (TextView())(view.pc());
              var tmp0_elvis_lhs_2 = view.ebb_1;
              var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
              view.gbb(p_2, view_2);
              view_2.lba(view_2.qb6_1.abf(BodySemantic_getInstance()));
              view_2.dbs(Align_Center_getInstance());
              var tmp_6 = KMutableProperty0();
              var tmp_7 = TextView$_get_content_$ref_4pzcwl_10(view_2);
              // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
              var this_2 = getPropertyCallableRef('content', 0, tmp_6, tmp_7, TextView$_set_content_$ref_pketfb_10(view_2));
              reactiveScope(view_2, ($this$reactiveScope) => {
                var ledger_0 = $this$reactiveScope.daj(ledger);
                var tmp$ret$122 = !(ledger_0.q7k_1 == null) ? 'Draw Payment' : !(ledger_0.p7k_1 == null) ? 'Work Item Approval' : 'Retention Release';
                this_2.set(tmp$ret$122);
                return Unit_instance;
              });
              view.hbb(p_2, view_2);
              view.lbb(tmp_5, view_2);
              var tmp_8 = view.kbb(get_centered(view), $this$trackWeights.pg6(view));
              // Inline function 'com.crowpay.views.theming.body' call
              // Inline function 'com.lightningkite.kiteui.views.direct.text' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_3 = new (TextView())(view.pc());
              var tmp0_elvis_lhs_3 = view.ebb_1;
              var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
              view.gbb(p_3, view_3);
              view_3.lba(view_3.qb6_1.abf(BodySemantic_getInstance()));
              view_3.dbs(Align_Center_getInstance());
              var tmp_9 = KMutableProperty0();
              var tmp_10 = TextView$_get_content_$ref_4pzcwl_11(view_3);
              // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
              var this_3 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb_11(view_3));
              reactiveScope(view_3, ($this$reactiveScope) => {
                var tmp$ret$129 = MonetaryValue__toStringAbsolute_impl_uovmiu($this$reactiveScope.daj(ledger).s7k_1);
                this_3.set(tmp$ret$129);
                return Unit_instance;
              });
              view.hbb(p_3, view_3);
              view.lbb(tmp_8, view_3);
              var tmp_11 = view.kbb(get_centered(view), $this$trackWeights.pg6(view));
              // Inline function 'com.crowpay.views.theming.body' call
              // Inline function 'com.lightningkite.kiteui.views.direct.text' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_4 = new (TextView())(view.pc());
              var tmp0_elvis_lhs_4 = view.ebb_1;
              var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
              view.gbb(p_4, view_4);
              view_4.lba(view_4.qb6_1.abf(BodySemantic_getInstance()));
              view_4.dbs(Align_Center_getInstance());
              var tmp_12 = KMutableProperty0();
              var tmp_13 = TextView$_get_content_$ref_4pzcwl_12(view_4);
              // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
              var this_4 = getPropertyCallableRef('content', 0, tmp_12, tmp_13, TextView$_set_content_$ref_pketfb_12(view_4));
              reactiveScope(view_4, ($this$reactiveScope) => {
                var tmp0_elvis_lhs = $this$reactiveScope.daj(ledger).t7k_1;
                var tmp;
                var tmp_0 = tmp0_elvis_lhs;
                if ((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null) {
                  tmp = Companion_instance.m62(0);
                } else {
                  tmp = tmp0_elvis_lhs;
                }
                var tmp$ret$136 = MonetaryValue__toStringAbsolute_impl_uovmiu(tmp);
                this_4.set(tmp$ret$136);
                return Unit_instance;
              });
              view.hbb(p_4, view_4);
              view.lbb(tmp_11, view_4);
              var tmp_14 = view.kbb(get_centered(view), $this$trackWeights.pg6(view));
              // Inline function 'com.crowpay.views.theming.body' call
              // Inline function 'com.lightningkite.kiteui.views.direct.text' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_5 = new (TextView())(view.pc());
              var tmp0_elvis_lhs_5 = view.ebb_1;
              var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
              view.gbb(p_5, view_5);
              view_5.lba(view_5.qb6_1.abf(BodySemantic_getInstance()));
              view_5.dbs(Align_Center_getInstance());
              var tmp_15 = KMutableProperty0();
              var tmp_16 = TextView$_get_content_$ref_4pzcwl_13(view_5);
              // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
              var this_5 = getPropertyCallableRef('content', 0, tmp_15, tmp_16, TextView$_set_content_$ref_pketfb_13(view_5));
              reactiveScope(view_5, ($this$reactiveScope) => {
                // Inline function 'kotlin.let' call
                var it = $this$reactiveScope.daj(ledger);
                var tmp = _MonetaryValue___get_absoluteValue__impl__hjldkw(it.s7k_1);
                var tmp0_elvis_lhs = it.t7k_1;
                var tmp_0;
                var tmp_1 = tmp0_elvis_lhs;
                if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
                  tmp_0 = Companion_instance.m62(0);
                } else {
                  tmp_0 = tmp0_elvis_lhs;
                }
                var tmp$ret$144 = MonetaryValue__minus_impl_jw9qyp(tmp, tmp_0);
                var tmp$ret$145 = MonetaryValue__toString_impl_xslc77(tmp$ret$144);
                this_5.set(tmp$ret$145);
                return Unit_instance;
              });
              view.hbb(p_5, view_5);
              view.lbb(tmp_14, view_5);
              $this$forEachById.hbb(p, view);
              return view;
            });
            view_6.hbb(p_9, view_9);
            view_6.lbb(tmp_17, view_9);
            view_5.hbb(p_6, view_6);
            view_5.lbb(tmp_12, view_6);
            // Inline function 'com.lightningkite.kiteui.views.card' call
            var tmp_20 = view_5.jbb(CardSemantic_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_10 = new (RowOrCol())(view_5.pc());
            var tmp0_elvis_lhs_10 = view_5.ebb_1;
            var p_10 = tmp0_elvis_lhs_10 == null ? view_5 : tmp0_elvis_lhs_10;
            view_5.gbb(p_10, view_10);
            view_10.zbm(false);
            var tmp_21 = get_expanding(view_10);
            // Inline function 'com.lightningkite.kiteui.views.direct.space' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_11 = new (Space())(view_10.pc());
            var tmp0_elvis_lhs_11 = view_10.ebb_1;
            var p_11 = tmp0_elvis_lhs_11 == null ? view_10 : tmp0_elvis_lhs_11;
            view_10.gbb(p_11, view_11);
            view_10.hbb(p_11, view_11);
            view_10.lbb(tmp_21, view_11);
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_12 = new (RowOrCol())(view_10.pc());
            var tmp0_elvis_lhs_12 = view_10.ebb_1;
            var p_12 = tmp0_elvis_lhs_12 == null ? view_10 : tmp0_elvis_lhs_12;
            view_10.gbb(p_12, view_12);
            view_12.zbm(false);
            var tmp_22 = get_centered(view_12);
            // Inline function 'com.crowpay.views.theming.body' call
            // Inline function 'com.lightningkite.kiteui.views.direct.text' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_13 = new (TextView())(view_12.pc());
            var tmp0_elvis_lhs_13 = view_12.ebb_1;
            var p_13 = tmp0_elvis_lhs_13 == null ? view_12 : tmp0_elvis_lhs_13;
            view_12.gbb(p_13, view_13);
            view_13.lba(view_13.qb6_1.abf(BodySemantic_getInstance()));
            var tmp_23 = KMutableProperty0();
            var tmp_24 = TextView$_get_content_$ref_4pzcwl_14(view_13);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_4 = getPropertyCallableRef('content', 0, tmp_23, tmp_24, TextView$_set_content_$ref_pketfb_14(view_13));
            reactiveScope(view_13, ($this$reactiveScope) => {
              var tmp$ret$168 = $this$reactiveScope.daj(status).equals(PaymentState_Succeeded_getInstance()) ? 'Total Deposited' : 'Total Deposit';
              this_4.set(tmp$ret$168);
              return Unit_instance;
            });
            view_12.hbb(p_13, view_13);
            view_12.lbb(tmp_22, view_13);
            var tmp_25 = get_centered(view_12);
            // Inline function 'com.crowpay.views.theming.bodyBold' call
            // Inline function 'com.lightningkite.kiteui.views.direct.text' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_14 = new (TextView())(view_12.pc());
            var tmp0_elvis_lhs_14 = view_12.ebb_1;
            var p_14 = tmp0_elvis_lhs_14 == null ? view_12 : tmp0_elvis_lhs_14;
            view_12.gbb(p_14, view_14);
            view_14.lba(view_14.qb6_1.abf(BodySemantic_getInstance().abf(BoldSemantic_getInstance())));
            var tmp_26 = KMutableProperty0();
            var tmp_27 = TextView$_get_content_$ref_4pzcwl_15(view_14);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_5 = getPropertyCallableRef('content', 0, tmp_26, tmp_27, TextView$_set_content_$ref_pketfb_15(view_14));
            reactiveScope(view_14, ($this$reactiveScope) => {
              // Inline function 'kotlin.collections.map' call
              var this_0 = $this$reactiveScope.daj(group).bf_1;
              // Inline function 'kotlin.collections.mapTo' call
              var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
              var _iterator__ex2g4s = this_0.m1();
              while (_iterator__ex2g4s.n1()) {
                var item = _iterator__ex2g4s.o1();
                var tmp$ret$175 = item.bjh_1;
                destination.v(tmp$ret$175);
              }
              // Inline function 'com.crowpay.extensions.sumMoney' call
              var sum = Companion_instance.r91(0n);
              var _iterator__ex2g4s_0 = destination.m1();
              while (_iterator__ex2g4s_0.n1()) {
                var element = _iterator__ex2g4s_0.o1();
                var tmp = sum;
                var tmp_0 = _MonetaryValue___get_absoluteValue__impl__hjldkw(element.s7k_1);
                var tmp0_elvis_lhs = element.t7k_1;
                var tmp_1;
                var tmp_2 = tmp0_elvis_lhs;
                if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
                  tmp_1 = Companion_instance.m62(0);
                } else {
                  tmp_1 = tmp0_elvis_lhs;
                }
                var tmp$ret$178 = MonetaryValue__minus_impl_jw9qyp(tmp_0, tmp_1);
                sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$178);
              }
              var tmp$ret$179 = sum;
              var tmp$ret$180 = MonetaryValue__toString_impl_xslc77(tmp$ret$179);
              this_5.set(tmp$ret$180);
              return Unit_instance;
            });
            view_12.hbb(p_14, view_14);
            view_12.lbb(tmp_25, view_14);
            view_10.hbb(p_12, view_12);
            view_5.hbb(p_10, view_10);
            view_5.lbb(tmp_20, view_10);
            view.hbb(p_5, view_5);
            view.lbb(tmp_9, view_5);
            $this$forEachById.hbb(p, view);
            return view;
          });
          view_1.hbb(p_7, view_7);
          view_1.lbb(tmp_5, view_7);
          this_2.hbb(p_1, view_1);
          return Unit_instance;
        });
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
      ljf(_this__u8e3s4) {
        var tmp = get_lightSection(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        var $this$col = view;
        trackWeights(($this$trackWeights) => {
          var tmp = get_compact($this$col);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          var this_0 = $this$col;
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())(this_0.pc());
          var tmp0_elvis_lhs = this_0.ebb_1;
          var p = tmp0_elvis_lhs == null ? this_0 : tmp0_elvis_lhs;
          this_0.gbb(p, view);
          view.zbm(true);
          title_0(view, 'Billing History');
          smallBody(view, 'Stoze collects 1% of transactions');
          this_0.hbb(p, view);
          $this$col.lbb(tmp, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          var this_1 = $this$col;
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (Space())(this_1.pc(), 0.5);
          var tmp0_elvis_lhs_0 = this_1.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? this_1 : tmp0_elvis_lhs_0;
          this_1.gbb(p_0, view_0);
          this_1.hbb(p_0, view_0);
          var tmp_0 = $this$col.kbb($this$col.jbb(FinanceTableSemantic_getInstance()), $this$col.jbb(ListSemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          var this_2 = $this$col;
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(this_2.pc());
          var tmp0_elvis_lhs_1 = this_2.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? this_2 : tmp0_elvis_lhs_1;
          this_2.gbb(p_1, view_1);
          view_1.zbm(true);
          var tmp_1 = view_1.jbb(HeaderSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (RowOrCol())(view_1.pc());
          var tmp0_elvis_lhs_2 = view_1.ebb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
          view_1.gbb(p_2, view_2);
          view_2.zbm(false);
          view_2.lbb(view_2.kbb(get_centered(view_2), $this$trackWeights.og6(view_2, 2.0)), body(view_2, 'PROJECT'));
          view_2.lbb(view_2.kbb(get_centered(view_2), $this$trackWeights.og6(view_2, 1.0)), centeredBody(view_2, 'DATE'));
          view_2.lbb(view_2.kbb(get_centered(view_2), $this$trackWeights.og6(view_2, 0.6)), centeredBody(view_2, 'DESCRIPTION'));
          view_2.lbb(view_2.kbb(get_centered(view_2), $this$trackWeights.og6(view_2, 0.4)), centeredBody(view_2, 'TYPE'));
          view_2.lbb(view_2.kbb(get_centered(view_2), $this$trackWeights.og6(view_2, 0.6)), centeredBody(view_2, 'METHOD'));
          view_2.lbb(view_2.kbb(get_centered(view_2), $this$trackWeights.og6(view_2, 1.0)), centeredBody(view_2, 'AMOUNT'));
          view_1.hbb(p_2, view_2);
          view_1.lbb(tmp_1, view_2);
          var bills = remember(VOID, VOID, VOID, ($this$remember) => {
            // Inline function 'kotlin.collections.filter' call
            var tmp0 = $this$remember.daj(this.ijf_1);
            // Inline function 'kotlin.collections.filterTo' call
            var destination = ArrayList().w();
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              var tmp = element.t7k_1;
              if (!((tmp == null ? null : new (MonetaryValue())(tmp)) == null)) {
                destination.v(element);
              }
            }
            return destination;
          });
          var withProject = remember(VOID, VOID, VOID, ($this$remember) => {
            // Inline function 'kotlin.collections.associateBy' call
            var this_0 = $this$remember.daj(this.fjf_1);
            var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
            // Inline function 'kotlin.collections.associateByTo' call
            var destination = LinkedHashMap().fc(capacity);
            var _iterator__ex2g4s = this_0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              var tmp$ret$14 = element.v7a_1;
              destination.s3(tmp$ret$14, element);
            }
            var projects = destination;
            // Inline function 'kotlin.collections.map' call
            var this_1 = $this$remember.daj(bills);
            // Inline function 'kotlin.collections.mapTo' call
            var destination_0 = ArrayList().u(collectionSizeOrDefault(this_1, 10));
            var _iterator__ex2g4s_0 = this_1.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var item = _iterator__ex2g4s_0.o1();
              var tmp$ret$17 = new (LedgerWithProject())(item, projects.p3(item.o7k_1));
              destination_0.v(tmp$ret$17);
            }
            return destination_0;
          });
          var tmp_2 = view_1.kbb(shownWhen(view_1, VOID, ($this$shownWhen) => $this$shownWhen.daj(withProject).i1()), view_1.jbb(NothingHereSemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (RowOrCol())(view_1.pc());
          var tmp0_elvis_lhs_3 = view_1.ebb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
          view_1.gbb(p_3, view_3);
          view_3.zbm(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (Space())(view_3.pc(), 0.5);
          var tmp0_elvis_lhs_4 = view_3.ebb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
          view_3.gbb(p_4, view_4);
          view_3.hbb(p_4, view_4);
          // Inline function 'com.crowpay.views.theming.boldSubTitle' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (TextView())(view_3.pc());
          var tmp0_elvis_lhs_5 = view_3.ebb_1;
          var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
          view_3.gbb(p_5, view_5);
          view_5.lba(view_5.qb6_1.abf(SubtitleSemantic_getInstance().abf(BoldSemantic_getInstance())));
          view_5.dbs(Align_Center_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var value = 'Nothing Yet';
          var tmp_3 = view_5.vb5_1;
          var tmp_4;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(value) === 0) {
            tmp_4 = '\xA0';
          } else {
            tmp_4 = value;
          }
          tmp_3.hbu(tmp_4);
          view_3.hbb(p_5, view_5);
          // Inline function 'com.crowpay.views.theming.smallBody' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_6 = new (TextView())(view_3.pc());
          var tmp0_elvis_lhs_6 = view_3.ebb_1;
          var p_6 = tmp0_elvis_lhs_6 == null ? view_3 : tmp0_elvis_lhs_6;
          view_3.gbb(p_6, view_6);
          view_6.lba(view_6.qb6_1.abf(SmallBodySemantic_getInstance()));
          view_6.dbs(Align_Center_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var value_0 = 'Bills will appear here when charged';
          var tmp_5 = view_6.vb5_1;
          var tmp_6;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(value_0) === 0) {
            tmp_6 = '\xA0';
          } else {
            tmp_6 = value_0;
          }
          tmp_5.hbu(tmp_6);
          view_3.hbb(p_6, view_6);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_7 = new (Space())(view_3.pc(), 0.5);
          var tmp0_elvis_lhs_7 = view_3.ebb_1;
          var p_7 = tmp0_elvis_lhs_7 == null ? view_3 : tmp0_elvis_lhs_7;
          view_3.gbb(p_7, view_7);
          view_3.hbb(p_7, view_7);
          view_1.hbb(p_3, view_3);
          view_1.lbb(tmp_2, view_3);
          var tmp_7 = view_1.jbb(ListSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_8 = new (RowOrCol())(view_1.pc());
          var tmp0_elvis_lhs_8 = view_1.ebb_1;
          var p_8 = tmp0_elvis_lhs_8 == null ? view_1 : tmp0_elvis_lhs_8;
          view_1.gbb(p_8, view_8);
          view_8.zbm(true);
          var tmp_8 = lens(withProject, ContractorPaymentInfo$billingHistoryTable$lambda$lambda);
          var tmp_9 = ContractorPaymentInfo$billingHistoryTable$lambda$lambda_0;
          forEachById(view_8, tmp_8, tmp_9, VOID, ($this$forEachById, indexed) => {
            var ledger = lens(indexed, ContractorPaymentInfo$billingHistoryTable$lambda$lambda$lambda);
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view = new (RowOrCol())($this$forEachById.pc());
            var tmp0_elvis_lhs = $this$forEachById.ebb_1;
            var p = tmp0_elvis_lhs == null ? $this$forEachById : tmp0_elvis_lhs;
            $this$forEachById.gbb(p, view);
            view.zbm(false);
            dynamicTheme(view, ($this$dynamicTheme) => ($this$dynamicTheme.daj(indexed).ll_1 % 2 | 0) === 0 ? CardSemantic_getInstance() : LightSection_getInstance());
            var tmp = view.kbb(get_centered(view), $this$trackWeights.pg6(view));
            // Inline function 'com.crowpay.views.theming.body' call
            // Inline function 'com.lightningkite.kiteui.views.direct.text' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_0 = new (TextView())(view.pc());
            var tmp0_elvis_lhs_0 = view.ebb_1;
            var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
            view.gbb(p_0, view_0);
            view_0.lba(view_0.qb6_1.abf(BodySemantic_getInstance()));
            var tmp_0 = KMutableProperty0();
            var tmp_1 = TextView$_get_content_$ref_4pzcwl_16(view_0);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_16(view_0));
            reactiveScope(view_0, ($this$reactiveScope) => {
              var tmp0_safe_receiver = $this$reactiveScope.daj(indexed).ml_1.cjh_1;
              var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b7b_1;
              var tmp$ret$44 = tmp1_elvis_lhs == null ? '...' : tmp1_elvis_lhs;
              this_0.set(tmp$ret$44);
              return Unit_instance;
            });
            view.hbb(p_0, view_0);
            view.lbb(tmp, view_0);
            var tmp_2 = view.kbb(get_centered(view), $this$trackWeights.pg6(view));
            // Inline function 'com.crowpay.views.theming.body' call
            // Inline function 'com.lightningkite.kiteui.views.direct.text' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_1 = new (TextView())(view.pc());
            var tmp0_elvis_lhs_1 = view.ebb_1;
            var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
            view.gbb(p_1, view_1);
            view_1.lba(view_1.qb6_1.abf(BodySemantic_getInstance()));
            view_1.dbs(Align_Center_getInstance());
            var tmp_3 = KMutableProperty0();
            var tmp_4 = TextView$_get_content_$ref_4pzcwl_17(view_1);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_1 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb_17(view_1));
            reactiveScope(view_1, ($this$reactiveScope) => {
              // Inline function 'kotlin.let' call
              var it = $this$reactiveScope.daj(ledger);
              var tmp0_elvis_lhs = it.a7l_1;
              var tmp$ret$52 = tmp0_elvis_lhs == null ? it.f7l_1 : tmp0_elvis_lhs;
              var tmp$ret$53 = renderDateToString(tmp$ret$52, RenderSize_Numerical_getInstance());
              this_1.set(tmp$ret$53);
              return Unit_instance;
            });
            view.hbb(p_1, view_1);
            view.lbb(tmp_2, view_1);
            view.lbb(view.kbb(get_centered(view), $this$trackWeights.pg6(view)), centeredBody(view, 'Escrow Fee'));
            view.lbb(view.kbb(view.kbb(get_centered(view), $this$trackWeights.pg6(view)), colored(view, AppColors_getInstance().hfz_1.zg9_1)), centeredBody(view, '1%'));
            view.lbb(view.kbb(get_centered(view), $this$trackWeights.pg6(view)), centeredBody(view, 'Hold Back'));
            var tmp_5 = view.kbb(get_centered(view), $this$trackWeights.pg6(view));
            // Inline function 'com.crowpay.views.theming.body' call
            // Inline function 'com.lightningkite.kiteui.views.direct.text' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_2 = new (TextView())(view.pc());
            var tmp0_elvis_lhs_2 = view.ebb_1;
            var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
            view.gbb(p_2, view_2);
            view_2.lba(view_2.qb6_1.abf(BodySemantic_getInstance()));
            view_2.dbs(Align_Center_getInstance());
            var tmp_6 = KMutableProperty0();
            var tmp_7 = TextView$_get_content_$ref_4pzcwl_18(view_2);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_2 = getPropertyCallableRef('content', 0, tmp_6, tmp_7, TextView$_set_content_$ref_pketfb_18(view_2));
            reactiveScope(view_2, ($this$reactiveScope) => {
              var tmp0_elvis_lhs = $this$reactiveScope.daj(ledger).t7k_1;
              var tmp;
              var tmp_0 = tmp0_elvis_lhs;
              if ((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null) {
                tmp = Companion_instance.m62(0);
              } else {
                tmp = tmp0_elvis_lhs;
              }
              var tmp$ret$60 = MonetaryValue__toStringAbsolute_impl_uovmiu(tmp);
              this_2.set(tmp$ret$60);
              return Unit_instance;
            });
            view.hbb(p_2, view_2);
            view.lbb(tmp_5, view_2);
            $this$forEachById.hbb(p, view);
            return view;
          });
          view_1.hbb(p_8, view_8);
          view_1.lbb(tmp_7, view_8);
          this_2.hbb(p_1, view_1);
          $this$col.lbb(tmp_0, view_1);
          return Unit_instance;
        });
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
    }
    initMetadataForClass($, 'ContractorPaymentInfo', VOID, VOID, VOID, [0, 1]);
    ContractorPaymentInfoClass = $;
  }
  return ContractorPaymentInfoClass;
}
//region block: exports
export {
  ContractorPaymentInfo as ContractorPaymentInfo1nscg9rquslpg,
};
//endregion

//# sourceMappingURL=ContractorPaymentInfo.mjs.map
